import * as React from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';


 const SearchInput= () =>{
  return (
    <Paper
      component="form"
      sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: "241px", borderRadius: "12px", height: "35px", border: "0.5px solid #000000" }}
    >
      <InputBase
        sx={{
          ml: 1, flex: 1,
          border: "none",
          fontFamily: "Montserrat",
          fontSize: "12px",
          fontWeight: 400,
          lineHeight: "14.63px",
          paddingLeft: "20px",
          textAlign: "left"
        }}
        placeholder="Enter Your Bid No."
        inputProps={{ 'aria-label': 'Enter Your Bid No.' }}
      />
      <IconButton type="button"
      sx={{
        p: '10px',
        '&:hover': {
          backgroundColor: 'transparent',
          color: 'inherit',
        }
        
      }} 
     >
        <SearchIcon />
      </IconButton>

    </Paper>
  );
}

export default SearchInput;